// extracted by mini-css-extract-plugin
export default {"QuantityLabel":"QuantityLabel-styles__QuantityLabel___u1Er","QuantityLabel__quantity":"QuantityLabel-styles__QuantityLabel__quantity__G3W3h"};